module.exports = __webpack_public_path__ + "img/logo.9d9bab3d.png";